module.exports = __webpack_public_path__ + "img/plan_logo_1.1ab745ed.png";